export enum SettingTabs {
  General = 'General',
  Classifications = 'Classifications',
  AcceptPayment = 'Accept Payment',
  Integrations = 'App & Integrations',
  AccountInformation = 'Account Information',
  Locations = 'Locations'
}

export interface Statistic {
  totalReferrals: number;
  currentlyInTrial: number;
  expiredTrials: number;
  totalConversions: number;
}

export interface Subscription {
  id: string;
  name: string;
  description: string | null;
  priceId: string | null;
  amount: number;
  trialDays: number;
}

export enum ECompanyStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Trial = 'Trial',
  Suspended = 'Suspended'
}

export interface Company {
  billingEmail: string;
  id: string;
  companyName: string;
  companyUrl: string;
  status: ECompanyStatus;
  trialEnd?: Date;
  tenant?: TenantList;
}

export enum ELocationOrderableFields {
  Name = 'name',
  Created = 'created'
}

export enum MapPolygonMode {
  Default = 'Default',
  Edit = 'Edit',
  Delete = 'Delete'
}

export interface polygonType {
  lat: number;
  lng: number;
}

export enum LocationSortableFields {
  companyName = 'companyName',
  tenantName = 'tenantName',
  status = 'status',
  created = 'created'
}

export type LocationListRequest = {
  Page: number | null;
  PageSize: number | null;
  Order: LocationSortableFields | null;
  Ascending: boolean | null;
};

export interface LocationDetail {
  id?: string;
  name: string;
  polygons: string;
  created: string;
}

export interface polygonsType {
  type: string;
  coordinates: [];
}

export enum EUserSortableFields {
  name = 'name',
  lastName = 'lastName',
  email = 'email',
  phoneNumber = 'phone',
  status = 'status'
}

export type UserListRequest = {
  Page: number | null;
  PageSize: number | null;
  Order: EUserSortableFields | null;
  Ascending: boolean | null;
};

export type UserDetail = {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  status: string;
};

export type TenantList = {
  hostname: string;
  id: string;
  name: string;
};

export type CompanyInformation = {
  companyInfo: Company;
  isEnabledSubscription: boolean;
  isCompanySuspended: boolean;
};

export type UserInfo = {
  hideAdminIntro: boolean;
};
